// Gera e baixa um CSV a partir de cabeçalhos + linhas — sem biblioteca nenhuma.
// Separador ";" e BOM UTF-8 (String.fromCharCode(0xFEFF), escrito assim pra não
// depender de como o editor salva um caractere invisível no arquivo) porque é o
// que o Excel em português espera pra abrir acentuação certa sem "importar dados".
export function baixarCsv(nomeArquivo, cabecalhos, linhas) {
  const escapar = (valor) => {
    const texto = String(valor ?? "");
    return /[",;\n]/.test(texto) ? `"${texto.replace(/"/g, '""')}"` : texto;
  };
  const conteudo = [cabecalhos, ...linhas]
    .map((linha) => linha.map(escapar).join(";"))
    .join("\r\n");

  const bom = String.fromCharCode(0xfeff);
  const blob = new Blob([bom + conteudo], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = nomeArquivo;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

// Lê um CSV (mesmo formato de baixarCsv: separador ";", aspas duplas pra
// escapar, com ou sem BOM UTF-8) e devolve um array de objetos usando a
// primeira linha como nomes das colunas. Sem biblioteca, mesmo espírito de
// baixarCsv.
export function lerCsv(texto) {
  const semBom = texto.charCodeAt(0) === 0xfeff ? texto.slice(1) : texto;
  const linhas = [];
  let linhaAtual = [];
  let campoAtual = "";
  let dentroAspas = false;

  for (let i = 0; i < semBom.length; i++) {
    const c = semBom[i];
    if (dentroAspas) {
      if (c === '"' && semBom[i + 1] === '"') { campoAtual += '"'; i++; }
      else if (c === '"') { dentroAspas = false; }
      else { campoAtual += c; }
    } else if (c === '"') {
      dentroAspas = true;
    } else if (c === ";") {
      linhaAtual.push(campoAtual);
      campoAtual = "";
    } else if (c === "\n" || c === "\r") {
      if (c === "\r" && semBom[i + 1] === "\n") i++;
      linhaAtual.push(campoAtual);
      campoAtual = "";
      if (linhaAtual.some((v) => v !== "")) linhas.push(linhaAtual);
      linhaAtual = [];
    } else {
      campoAtual += c;
    }
  }
  if (campoAtual !== "" || linhaAtual.length) {
    linhaAtual.push(campoAtual);
    linhas.push(linhaAtual);
  }
  if (linhas.length < 2) return [];

  const cabecalhos = linhas[0].map((h) => h.trim());
  return linhas.slice(1).map((linha) => {
    const obj = {};
    cabecalhos.forEach((h, i) => { obj[h] = (linha[i] ?? "").trim(); });
    return obj;
  });
}
